// start user address helper functions
const ADDRESS_MODES = {
  NATIONAL: 'nation',
  AUTO: 'auto',
  Manual: 'manual',
};
export const buildPayload = ({
  submittedValues,
  selectedAddress,
  user,
  addressType,
}) => {
  return {
    ...(selectedAddress?.id && { id: selectedAddress.id }),
    customer_id: user?.id,
    region: {
      region_code: '',
      region: submittedValues?.region,
      region_id: submittedValues?.region_id,
    },
    region_id: submittedValues?.region_id,
    country_id: 'SA',
    street: [submittedValues?.street] || [],
    telephone: user?.mobilenumber,
    postcode: '10577',
    city: submittedValues?.city?.replaceAll('.', '') || submittedValues?.region,
    firstname: user?.firstname,
    lastname: '',
    default_billing: selectedAddress?.default_billing,
    default_shipping: selectedAddress?.default_shipping,
    custom_attributes: {
      ...(addressType === ADDRESS_MODES.NATIONAL && {
        national_address: submittedValues?.nationalAddress,
      }),
      delivery_instructions: submittedValues?.deliveryInstruction,
      city_id: submittedValues?.city_id,
      address_type: addressType,
      ...(addressType === ADDRESS_MODES.AUTO && {
        lat: submittedValues?.lat,
        lng: submittedValues?.long,
      }),
    },
    extension_attributes: {
      building_number: submittedValues?.buildingNumber,
    },
  };
};

export const getInitialValues = ({
  user,
  isEditMode,
  selectedAddress,
  mode,
}) => {
  const mobileNumber = user?.mobilenumber
    ? `0${user?.mobilenumber?.slice(-9)}`
    : '';

  const getCustomAttribute = (code, selectedAddress) =>
    selectedAddress?.custom_attributes?.find(
      (item) => item?.attribute_code === code
    )?.value || '';

  const baseValues = {
    name: `${user?.firstname || ''}`.trim(),
    phone: mobileNumber,
    email: user?.email || '',
    deliveryInstrucation: '',
  };

  if (isEditMode) {
    return {
      ...baseValues,
      ...(mode === ADDRESS_MODES.AUTO && {
        lat: selectedAddress?.lat || '',
        long: selectedAddress?.long || '',
      }),
      address: selectedAddress?.street?.[0] || '',
      name: `${selectedAddress?.firstname || ''}`.trim(),
      phone: `0${selectedAddress?.telephone?.slice(-9)}` || mobileNumber,
      deliveryInstrucation: getCustomAttribute(
        'delivery_instructions',
        selectedAddress
      ),
      ...(mode !== ADDRESS_MODES.AUTO && {
        city: selectedAddress?.city || '',
        region: selectedAddress?.region?.region?.toString() || '',
        region_id: selectedAddress?.region?.region_id?.toString() || '',
      }),
      ...(mode === ADDRESS_MODES.NATIONAL && {
        nationalAddress: getCustomAttribute(
          'national_address',
          selectedAddress
        ),
      }),
    };
  }

  return {
    ...baseValues,
    address: '',
    ...(mode !== ADDRESS_MODES.AUTO && {
      city: '',
      region: '',
    }),
    ...(mode === ADDRESS_MODES.NATIONAL && {
      nationalAddress: '',
    }),

    ...(mode === ADDRESS_MODES.AUTO && {
      lat: '',
      long: '',
    }),
  };
};
// end user address helper functions
